import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const Wrapper = styled.div`
  width: ${() => `${viewSizeCalculator(21.5)}`}; // 22.5rem
  height: ${() => `${viewSizeCalculator(4)}`}; // 4rem
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropdownContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #ffffff;
  box-shadow: 0 0.0625rem 0.3125rem #3333331a;
  cursor: pointer;
`;

export const SelectedItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${() => `0 ${viewSizeCalculator(0.5)}`}; // 1rem
  padding-left: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  height: 100%;
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  font-weight: 700;
  color: #333333;

  img {
    width: ${() => `${viewSizeCalculator(2.5)}`}; // 1.5rem
    height: ${() => `${viewSizeCalculator(2.5)}`}; // 2.5rem
  }
`;

export const DropdownIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: ${() => `${viewSizeCalculator(3)}`};
    height: ${() => `${viewSizeCalculator(3)}`};
    fill: ${({ isOpen }) => (isOpen ? "#F6F6F6" : "#fff")};
    transition: fill 0.3s ease-in-out;

    &:hover {
      fill: #f6f6f6;
    }
  }
`;
